import React from "react";
import { ReactP5Wrapper } from "react-p5-wrapper"; // im using "react-p5-wrapper": "^3.0.2", do not remove this comment

function grid(p) {
  const GRID_COLOR = [200, 200, 200, 80];
  p.push();
  p.stroke(...GRID_COLOR);
  p.strokeWeight(1);
  let step = 40;
  let gridSize = 2000;
  for (let x = -gridSize; x <= gridSize; x += step) {
    p.line(x, -gridSize, x, gridSize);
  }
  for (let y = -gridSize; y <= gridSize; y += step) {
    p.line(-gridSize, y, gridSize, y);
  }
  p.pop();
}

export const Gottman = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {
  const sketch = (p) => {
    const BLACK = [51, 51, 51];
    const PINK = [235, 93, 123];
    const BLUE = [93, 105, 235];
    const BEIGE = [255, 254, 246];

    let titleText = 'Gottman Stability Ratio';
    // let firstText = 'P : Positive Interactions    N : Negative Interactions';
    // let firstText = 'To keep a relationship afloat,';
    // let secondText = 'you need five parts light for every one part heavy.'
    // let firstText = 'It takes only a second to be cold and leave a scar,';
    // let secondText ='it takes five gentle touches to make the heart feel new.'
    let firstText = 'One step away from each other is easy to take,'
    let secondText = 'it takes five gentle breaths to find the rhythm we lost.'
    let thirdText = 'you need five parts light for every one part heavy.'
    let latoFont = "Lato";
    let titleWidths = []; // Added for top title
    let firstWidths = [];
    let secondWidths = [];
    let thirdWidths = [];
    let spaceKerning = 4.75;

    // --- Floating Text Logic ---
    let particles = [];
    const posPhrases = ["Kindness", "Listening", "A Smile", "Affection", "Gratitude", "Support", "Validation", "Shared Joy"];
    const negPhrases = ["Criticism", "Sarcasm", "Coldness", "Ignoring", "Eye-roll", "Judgment", "Defensiveness"];

    const letter_extra_space = {
      a: 1.05, b: 1, c: 1, d: 1, e: 1.5, f: 0, g: 1, h: 1, i: 1, j: 1,
      k: 1, l: 0.1, m: 1, n: 1, o: 1, p: 1, q: 1, r: -0.2, s: 2, t: 0,
      u: 1, v: 0, w: 0, x: 1, y: 1, z: 1,
    };

    function loadGoogleFont() {
      const link = document.createElement("link");
      link.href = "https://fonts.googleapis.com/css2?family=Lato:wght@300;400&display=swap";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }

    p.setup = () => {
      loadGoogleFont();
      p.createCanvas(wt, ht);
      p.rectMode(p.CENTER);
      p.ellipseMode(p.CENTER);
      p.textAlign(p.LEFT, p.CENTER);
      p.textSize(fs);
      p.textFont(latoFont);

      // Measure Title
      for (let i = 0; i < titleText.length; i++) {
        let extra = titleText[i] === " " ? spaceKerning : letter_extra_space[titleText[i]] || 0;
        titleWidths[i] = p.textWidth(titleText[i]) + extra;
      }

      for (let i = 0; i < firstText.length; i++) {
        let extra = firstText[i] === " " ? spaceKerning : letter_extra_space[firstText[i]] || 0;
        firstWidths[i] = p.textWidth(firstText[i]) + extra;
      }

      for (let i = 0; i < secondText.length; i++) {
        let extra = secondText[i] === " " ? spaceKerning : letter_extra_space[secondText[i]] || 0;
        secondWidths[i] = p.textWidth(secondText[i]) + extra;
      }

      for (let i = 0; i < thirdText.length; i++) {
        let extra = thirdText[i] === " " ? spaceKerning : letter_extra_space[thirdText[i]] || 0;
        thirdWidths[i] = p.textWidth(thirdText[i]) + extra;
      }
    };

    const statictext_old = () => {
      p.push();
      p.textSize(fs);
      p.textFont(latoFont);
      p.textAlign(p.LEFT, p.CENTER);

      let cx = p.width / 2;
      let titleY = 50; // Top area
      let firstY = p.height - 120;
      let secondY = firstY + 24;
      let thirdY = secondY + 24;

      let titleWidth = titleWidths.reduce((a, b) => a + b, 0);
      let firstWidth = firstWidths.reduce((a, b) => a + b, 0);
      let secondWidth = secondWidths.reduce((a, b) => a + b, 0);
      let thirdWidth = thirdWidths.reduce((a, b) => a + b, 0);

      // --- Title: Top Center ---
      p.fill(BLACK);
      let tx = cx - titleWidth / 2;
      for (let i = 0; i < titleText.length; i++) {
        p.text(titleText[i], tx, titleY);
        tx += titleWidths[i];
      }

      // --- Line 1: P : Positive... N : Negative... ---
      let x1 = cx - firstWidth / 2;
      for (let i = 0; i < firstText.length; i++) {
        if (i < firstText.indexOf('N')) {
          p.fill(BLUE);
        } else {
          p.fill(PINK);
        }
        p.text(firstText[i], x1, firstY);
        x1 += firstWidths[i];
      }

      // Line 2
      p.fill(BLACK);
      let x2 = cx - secondWidth / 2;
      for (let i = 0; i < secondText.length; i++) {
        p.text(secondText[i], x2, secondY);
        x2 += secondWidths[i];
      }

      // --- Line 3: To keep a relationship afloat... ---
      p.fill(BLACK);
      let x3 = cx - thirdWidth / 2;
      for (let i = 0; i < thirdText.length; i++) {
        p.text(thirdText[i], x3, thirdY);
        x3 += thirdWidths[i];
      }
      p.pop();
    };


    const titletext = ()=>{
      p.push();
      p.textSize(fs);
      p.textFont(latoFont);
      p.fill(...BLACK);
      let cx = p.width / 2;
      let titleY = 50; // Top area

      let titleWidth = titleWidths.reduce((a, b) => a + b, 0);
        // --- Title: Top Center ---
        p.fill(BLACK);
        let tx = cx - titleWidth / 2;
        for (let i = 0; i < titleText.length; i++) {
          p.text(titleText[i], tx, titleY);
          tx += titleWidths[i];
        }
    }

    const statictext = () => {
      p.push();
      p.textSize(fs);
      p.textFont(latoFont);
      p.fill(...BLACK);

    
      let firstWidth = firstWidths.reduce((a, b) => a + b, 0);
      let secondWidth = secondWidths.reduce((a, b) => a + b, 0);

    
      let x1 = p.width / 2 - firstWidth / 2;
      for (let i = 0; i < firstText.length; i++) {
        p.text(firstText[i], x1, p.height - 120);
        x1 += firstWidths[i];
      }

      let x2 = p.width / 2 - secondWidth / 2;
      for (let i = 0; i < secondText.length; i++) {
        p.text(secondText[i], x2, p.height - 92);
        x2 += secondWidths[i];
      }
      p.pop();
    };

    const maincontent = () => {
      p.push();

      const formulaSize = fs * 3.5;
      p.textSize(formulaSize);
      p.textFont(latoFont);

      let lineW = formulaSize * 0.8;
      let resultText = " ≥ 5";
      let resultW = p.textWidth(resultText);
      let totalContentWidth = lineW + resultW;

      // Center adjustment
      p.translate(p.width / 2 - (totalContentWidth / 2) + (lineW / 2), p.height / 2.25);

      p.textAlign(p.CENTER, p.CENTER);
      p.noStroke();

      // P and N
      p.fill(BLUE);
      p.text("P", 0, -formulaSize * 0.4);
      p.fill(PINK);
      p.text("N", 0, formulaSize * 0.65);

      p.fill(BLACK);

      // Vinculum
      p.stroke(BLACK);
      p.strokeWeight(3);
      p.line(-lineW / 2, 5, lineW / 2, 5);

      // Result Text
      p.noStroke();
      p.textAlign(p.LEFT, p.CENTER);
      p.text(resultText, lineW / 2, 0);

      // --- Floating Particle Logic ---

      // Spawn Positive: Every 40 frames (~5 times as often)
      if (p.frameCount % 40 === 0) {
        particles.push({
          txt: p.random(posPhrases),
          y: -formulaSize * 1,
          opacity: 255,
          speed: -0.6, // Rising
          type: 'pos',
          color: BLUE
        });
      }

      // Spawn Negative: Every 200 frames (Rarely)
      if (p.frameCount % 200 === 0) {
        particles.push({
          txt: p.random(negPhrases),
          y: formulaSize * 1.2,
          opacity: 255,
          speed: 0.6, // Sinking
          type: 'neg',
          color: PINK
        });
      }

      p.textSize(fs * 0.9);
      p.textAlign(p.CENTER, p.CENTER);
      for (let i = particles.length - 1; i >= 0; i--) {
        let part = particles[i];

        // Slightly different color for negative to provide visual cue
        if (part.type === 'neg') p.fill(part.color[0], part.color[1], part.color[2], part.opacity);
        else p.fill(part.color[0], part.color[1], part.color[2], part.opacity);

        p.text(part.txt, 0, part.y);

        part.y += part.speed;
        part.opacity -= 1.5;

        if (part.opacity <= 0) {
          particles.splice(i, 1);
        }
      }

      p.pop();
    };

    p.draw = () => {
      p.background(BEIGE);
      grid(p);
      maincontent();
      titletext();
      statictext();
    };
  };

  return (
    <div style={{ backgroundColor: bgcolor }}>
      <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
        <ReactP5Wrapper sketch={sketch} />
      </div>
    </div>
  );
};

export default Gottman;